// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoModalWrapper_wrapper__7WXU+","title":"InfoModalWrapper_title__eam4w","buttonsWrapper":"InfoModalWrapper_buttonsWrapper__9Y-bq"};